export const fmt = (n, d = 2) =>
  n === null || n === undefined || isNaN(n)
    ? "—"
    : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const money = (n, d = 2) => (n < 0 ? "-$" : "$") + fmt(Math.abs(n ?? 0), d);

export const signed = (n, d = 2) => (n > 0 ? "+" : n < 0 ? "-" : "") + fmt(Math.abs(n ?? 0), d);

export const signedMoney = (n, d = 2) =>
  (n > 0 ? "+" : n < 0 ? "-" : "") + "$" + fmt(Math.abs(n ?? 0), d);

export const pct = (n, d = 2) => signed(n, d) + "%";

export const timeOf = (iso) => {
  if (!iso) return "—";
  try {
    const dt = new Date(iso);
    return dt.toLocaleTimeString("en-US", { hour12: false });
  } catch {
    return "—";
  }
};

export const pnlColor = (n) => (n > 0 ? "text-green-500" : n < 0 ? "text-red-500" : "text-zinc-400");
